import AddIcon from '@mui/icons-material/Add';
import { IconButton, IconButtonProps } from 'shared/mui/IconButtons';

export type AddIconButtonProps = Omit<IconButtonProps, 'icon'>;

export function AddIconButton(props: AddIconButtonProps) {
  return (
    <IconButton {...props}>
      <AddIcon fontSize="inherit" />
    </IconButton>
  );
}
